import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'
import { CSESlideIn } from '@cloudsuite/mosaic-elements'
import { BasketCreatedEvent, BasketFormResetEvent } from 'components/ordering/multiple-baskets/basket-events.js'
import { slideInStyle } from 'components/ordering/multiple-baskets/basket.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import 'components/ordering/multiple-baskets/basket-creator/basket-creator.js'


initializeIconsByRole({
  'csc-basket-creator-slide-in.new': { name: 'circle-plus', style: 'light' },
})

@customElement('csc-basket-creator-slide-in')
export class CSCBasketCreatorSlideIn extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, slideInStyle]

  constructor() {
    super()
    this.addEventListener(BasketCreatedEvent.type, this.close)
    this.addEventListener(BasketFormResetEvent.type, this.close)
  }

  @property({ attribute: 'ordering-endpoint' })
  orderingEndpoint = ''

  @property({ attribute: 'party-id' })
  partyId = ''

  @property({ attribute: 'shop-id' })
  shopId = ''

  @query('cse-slide-in')
  slideIn!: CSESlideIn

  close() {
    this.slideIn.close()
  }

  override render() {
    return html`
      <cse-button fit="fill" @click="${() => this.slideIn.open()}">
        <cse-icon icon-role="csc-basket-creator-slide-in.new" slot="prefix"></cse-icon>
        ${t('open_slide_in_button', { ns: 'csc-basket-creator-slide-in', default: 'New Basket' })}
      </cse-button>

      <cse-slide-in class="slide-in">
        <div slot="header">
          ${t('header', { ns: 'csc-basket-creator-slide-in', default: 'New Basket' })}
        </div>

        <cse-text>
          <cse-icon icon-role="csc-basket-creator-slide-in.new" class="icon"></cse-icon>
        </cse-text>

        <cse-text>
          ${t('description', { ns: 'csc-basket-creator-slide-in', default: 'We will save your current basket so you can get started on your new one right away. You can complete your saved basket at any time. Are you sure you want to continue?' })}
        </cse-text>

        <csc-basket-creator
          ordering-endpoint="${this.orderingEndpoint}"
          party-id="${this.partyId}"
          shop-id="${this.shopId}"
          class="basket_creator"
        ></csc-basket-creator>
      </cse-slide-in>
    `
  }
}
